import React from "react";
import BaseComponent from "../../common/BaseComponent";
import { Table } from "antd";
import { RetrunReasonLogInput } from "../input";
import "./style/index.scss";

export default class ReturnReasonLogTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      dataSource: [],
    };
    // @ts-ignore
    this.columns = [
      {
        title: "Return Date",
        dataIndex: "returnDate",
        key: "returnDate",
      },
      {
        title: "Returned By",
        dataIndex: "returnedBy",
        key: "returnedBy",
      },
      {
        title: "Return Reason",
        dataIndex: "returnReasonColumn",
        key: "returnReasonColumn",
        className: "returnReasonColumn",
        width: "47%",
        render: (text: any) => (
          <RetrunReasonLogInput
            value={text}
            expendTextAreaClassName="returnReasonDetail"
            ref={this.props.reasonRef}
            readonly="readonly"
            disabled
            isScrollExpend={true}
          />
        ),
      },
    ];
  }

  render() {
    return (
      <div className="returnReasonLogTable">
        {/* @ts-ignore */}
        <Table
          key={this.props.tableKey}
          className="antTable"
          dataSource={this.props.dataSource}
          columns={(this as any).columns}
          pagination={false}
        />
      </div>
    );
  }
}
